import React, { useState, useEffect, useRef, createRef } from "react";
import { Card } from "../../../../common";
import { OwnershipProfileItem } from "./OwnershipProfileItem";
import { GraphStructure } from "./GraphStructure";
import useScreenSize from "../../../../../Hooks/useScreenSize";
import { ReactComponent as PaginationArrow } from "../../../../../assets/icons/paginationRight.svg";

export const CompanyOwnershipStructure = ({ ownershipCompany }) => {
  const [graphData, setGraphData] = useState([]);
  const { isMobile, isTablet, isDesktop } = useScreenSize();
  const [totalPercentHeld, settotalPercentHeld] = useState(0);

  useEffect(() => {
    if (ownershipCompany) {
      let totalPercent = 0;
      const result = ownershipCompany.map(item => {
        let currentType, value, ownerId, ownerName;
        if (item.ownershipID.ownership_indID) {
          totalPercent = totalPercent + item.ownershipID.ownership_indID.percentage_of_shares_held;
          currentType = item.ownershipID.ownership_indID.type;
          value = item.ownershipID.ownership_indID.percentage_of_shares_held;
          ownerId = item.ownershipID.ownership_indID.ownerId;
          ownerName = item.ownershipID.ownership_indID.ownerName;
        } else if (item.ownershipID.ownership_compID) {
          totalPercent = totalPercent + item.ownershipID.ownership_compID.percentage_of_shares_held;
          currentType = item.ownershipID.ownership_compID.type;
          value = item.ownershipID.ownership_compID.percentage_of_shares_held;
          ownerId = item.ownershipID.ownership_compID.ownerId;
          ownerName = item.ownershipID.ownership_compID.ownerName;
        }
        const color = currentType === "individual" ? "#EB3379" : "#6B3372";
        return {
          type: currentType,
          value,
          color,
          ownerId,
          ownerName
        };
      });
      settotalPercentHeld(parseInt(totalPercent));

      if (result.length > 0) {
        setGraphData(result);
      }
    }
  }, []);



  const tabs = [
    {
      title: "Sheikh Zayed ",
      designation: "CEO",
      content: "Content for Tab 1",
      value: 10,
      color: "#EB3379",
    },
    {
      title: "Latifa Rashid",
      designation: "COO",
      content: "Content for Tab 3",
      value: 20,
      color: "#44B2B3",
    },
    {
      title: "Latifa Rashid 4",
      designation: "CTO",
      content: "Content for Tab 4",
      value: 30,
      color: "#FCB316",
    },
    {
      title: "Latifa Rashid 5",
      designation: "CFO",
      content: "Content for Tab 5",
      value: 20,
      color: "#6B3372",
    },
    {
      title: "Latifa Rashid 6",
      designation: "CMO",
      content: "Content for Tab 6",
      value: 10,
      color: "#FF00CF",
    },
    {
      title: "Latifa Rashid 7",
      designation: "CSO",
      content: "Content for Tab 7",
      value: 10,
      color: "#FF80DF",
    },
  ];

  const containerRef = useRef(null);
  const [currentTab, setCurrentTab] = useState(0);

  const prevTab = () => {
    setCurrentTab((oldTab) => (oldTab > 0 ? oldTab - 1 : oldTab));
  };

  const nextTab = () => {
    setCurrentTab((oldTab) =>
      oldTab < ownershipCompany.length - 1 ? oldTab + 1 : oldTab
    );
  };

  const selectTab = (index) => {
    setCurrentTab(index);
  };

  const containerCarousel = useRef(null);

  const btnPressPrev = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft -= containerWidth;
    }
  };

  const btnPressNext = () => {
    if (containerCarousel.current) {
      const containerWidth = containerCarousel.current.offsetWidth;
      containerCarousel.current.scrollLeft += containerWidth;
    }
  };

  return (
    <Card classes=" rounded-xl bg-white p-6 mb-6">
      <h4 className="text-[18px] sm:text-f18 text-primary mb-4 font-semibold text-left">
        Company Ownership Structure
      </h4>
      <div className="rounded-xl relative">
        <div className={`rounded-xl flex containerCarousel flex overflow-x-hidden scroll-smooth ${isMobile ? "px-3" : "py-3 mx-6 px-0"}`} ref={containerCarousel}>
          {ownershipCompany.map((tab, index) => (
            <button
              key={index}
              onClick={() => selectTab(index)}
              className={`px-4 pr-2 py-2 m-1 text-[10px] sm:text-f14 text-primary flex items-center gap-3 rounded-full min-w-full sm:min-w-[250px] ${currentTab === index
                ? "bg-slate text-blank border border-primary"
                : "bg-white text-black border border-input"
                } rounded`}
            >
              <span
                className={`w-4 h-4 ${tab?.ownershipID?.ownership_indID?.type
                  ? "bg-CEO"
                  : "bg-CFO"
                  }
                  } rounded-full`}
              ></span>
              <div className="flex  flex-col text-left">
                <span style={{ fontSize: "10px" }}>
                  {tab?.ownershipID?.ownership_indID?.name ||
                    tab?.ownershipID?.ownership_compID?.company_name}
                </span>
                <span style={{ fontSize: "9px" }} className="text-[9px] text-secondary uppercase">
                  {tab?.ownershipID?.ownership_indID?.type ||
                    tab?.ownershipID?.ownership_compID?.type}
                </span>
              </div>
            </button>
          ))}
        </div>
        <div className={`carousel_box overflow-hidden ${isMobile ? "p-4" : "p-0"}`}>
          <button className={`pre-btn rotate-180 ${!isMobile && "absolute left-0 top-[30px]"}`} onClick={btnPressPrev}>
            <PaginationArrow />
          </button>
          <button className={`pre-btn ${!isMobile && "absolute right-0 top-[30px]"}`} onClick={btnPressNext}>
            <PaginationArrow />
          </button>
        </div>
      </div>
      <hr className="mt-4" />
      <div className="mt-4">
        <div className="flex pkp flex-col sm:flex-row gap-4 items-center " style={{ justifyContent: "center" }}>
          {totalPercentHeld == 100 && <GraphStructure data={graphData} />}
          <OwnershipProfileItem
            profile={
              ownershipCompany[currentTab]?.ownershipID?.ownership_indID ||
              ownershipCompany[currentTab]?.ownershipID?.ownership_compID
            }
            designation={
              ownershipCompany[currentTab]?.ownershipID?.ownership_indID
                ?.type ||
              ownershipCompany[currentTab]?.ownershipID?.ownership_compID
                ?.type
            }
          />
        </div>
      </div>
    </Card>
  );
};
